import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Testimonial } from '../models/testimonial';

@Injectable({
  providedIn: 'root'
})
export class TestimonailsService {

  constructor(
    private _http: HttpClient
  ) { }

  public getTestimonial(id:number): Observable<any>{
    return this._http.get(environment.apiEndpoint+'/api/admin/testimonial/'+id).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public getTestimonials(page:number, perPage:number):Observable<any>{
    return this._http.get(environment.apiEndpoint+'/api/admin/testimonials?page='+page+'&pp='+perPage).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public updateTestimonial(testimonial:Testimonial): Observable<any>{
    return this._http.put(environment.apiEndpoint+'/api/admin/testimonials/'+testimonial.id, {testimonial:testimonial}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }

  public createTestimonial(testimonial:Testimonial): Observable<any>{
    return this._http.post(environment.apiEndpoint+'/api/admin/testimonials', {testimonial:testimonial}).pipe(
      map(
        res=>{
          return res;
        }
      )
    );
  }
}
